var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "showLargeScreenOnly" },
    [
      _c(
        "a",
        {
          staticClass: "sr-only sr-only-focusable skip-link",
          attrs: { href: "#main-content" },
        },
        [_vm._v("Aller au contenu principal")]
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        {
          staticClass:
            "header-top d-flex justify-content-between align-items-center p-2",
          attrs: { type: "faded", role: "banner" },
        },
        [
          _c(
            "b-navbar-brand",
            {
              staticClass: "d-flex align-items-center py-0",
              attrs: { href: "#" },
            },
            [
              _c("img", {
                staticClass: "heritage-web-header largescreen",
                attrs: { src: _vm.imgVarsLong, alt: "DealPrudence" },
                on: { click: _vm.loadAccueil },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "mx-0", attrs: { fill: "" } },
                [
                  this.$engine.firstOn().user &&
                  this.$engine.firstOn().user.userAccountId !== 1
                    ? _c(
                        "b-nav-item-dropdown",
                        {
                          ref: "log",
                          staticClass: "logOut",
                          attrs: {
                            "toggle-class": "d-flex align-items-center",
                            right: "",
                            variant: "link",
                            "aria-label": _vm.$t("common.user_menu"),
                          },
                          nativeOn: {
                            mouseover: function ($event) {
                              return _vm.autoDropdown(true, "log")
                            },
                            mouseleave: function ($event) {
                              return _vm.autoDropdown(false, "log")
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("img", {
                                      staticClass: "navbarProfileImage mr-2",
                                      attrs: {
                                        src: _vm.imgProfil,
                                        alt: _vm.$t("common.profile_picture"),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-column align-items-start",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline mr-2 mb-0 text-menu profile-menu font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.companyName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-inline mr-2 mb-0 text-menu profile-menu",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.userName) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1215307368
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              staticClass:
                                "subItemTextWebHeader dropdown-item-web-header",
                              on: {
                                click: function ($event) {
                                  return _vm.goToLink("/profile/")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("leftPanelTitle.my_prfl")))]
                          ),
                          _vm._v(" "),
                          _vm.hasMultipleAccounts()
                            ? _c(
                                "b-dropdown-item",
                                {
                                  staticClass:
                                    "subItemTextWebHeader dropdown-item-web-header",
                                  on: { click: _vm.activateModalProfile },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("leftPanelTitle.swtch_prfl"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$engine
                            .firstOn()
                            .rights.rightIs("settings_consult", true)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  staticClass:
                                    "subItemTextWebHeader dropdown-item-web-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToLink(
                                        "/settings/application/"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("Webheader.settings")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              staticClass:
                                "subItemTextWebHeader dropdown-item-web-header",
                              on: { click: _vm.logout },
                            },
                            [_vm._v(_vm._s(this.$t("leftPanelTitle.lgout")))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "mx-0 mx-lg-1", attrs: { fill: "" } },
                [
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: {
                        right: "",
                        "toggle-class":
                          "border-0 p-0 bg-none m-md-2 text-dark bg-none-first-child",
                        "aria-label": _vm.$t("common.language_selector"),
                      },
                    },
                    [
                      _c("template", { slot: "button-content" }, [
                        _c("img", {
                          staticClass: "flag-nav",
                          attrs: {
                            src:
                              _vm.language === "FR"
                                ? _vm.logoFlagFR
                                : _vm.logoFlagEN,
                            alt:
                              _vm.language === "FR"
                                ? "Drapeau français"
                                : "Drapeau anglais",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "d-inline" }, [
                          _vm._v(_vm._s(_vm.labelLanguage)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.options, function (option) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: option.value,
                            staticClass: "dropdown-item-web-header",
                            on: {
                              click: function ($event) {
                                return _vm.languageCountry(option.value)
                              },
                            },
                          },
                          [
                            option.value === "FR"
                              ? _c("img", {
                                  staticClass: "flag-nav",
                                  attrs: {
                                    src: _vm.logoFlagFR,
                                    alt: "Drapeau français",
                                  },
                                })
                              : _c("img", {
                                  staticClass: "flag-nav",
                                  attrs: {
                                    src: _vm.logoFlagEN,
                                    alt: "Drapeau anglais",
                                  },
                                }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(option.text))]),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        {
          staticClass: "header-bottom d-flex justify-content-center p-1",
          attrs: {
            type: "faded",
            role: "navigation",
            "aria-label": "Navigation principale",
          },
        },
        [
          _c(
            "nav",
            {
              ref: "navigationContainer",
              staticClass: "w-100",
              attrs: { role: "navigation", "aria-label": "Menu principal" },
            },
            [
              _c(
                "b-navbar-nav",
                {
                  key: _vm.resetMenu,
                  ref: "navMenu",
                  staticClass:
                    "m-auto justify-content-center responsive-nav-menu",
                  attrs: { fill: "" },
                },
                [
                  _vm._l(_vm.menu, function (item, id) {
                    return [
                      !item.hidden &&
                      !_vm.isDisabledItem(item) &&
                      item.list &&
                      _vm.hasOneRight(item.list)
                        ? _c(
                            "b-nav-item-dropdown",
                            {
                              key: "dropdown-" + id,
                              ref: "dropdown" + id,
                              refInFor: true,
                              staticClass:
                                "font-weight-bold dropDownInnerWebHeader px-1 py-0 mt-1 small",
                              class: {
                                selectedMenuItemWebHeader: item.list.some(
                                  function (e) {
                                    return _vm.selectedMenu === e.link
                                  }
                                ),
                              },
                              attrs: {
                                text: _vm.$t(item.title),
                                "toggle-class": "text-menu",
                                "aria-label": _vm.$t(item.title),
                                "aria-haspopup": "true",
                                "aria-expanded": false,
                              },
                              nativeOn: {
                                mouseover: function ($event) {
                                  return _vm.autoDropdown(true, "dropdown" + id)
                                },
                                mouseleave: function ($event) {
                                  return _vm.autoDropdown(
                                    false,
                                    "dropdown" + id
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "inline-block" },
                                  attrs: { slot: "button-content" },
                                  slot: "button-content",
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t(item.title))),
                                  ]),
                                  _vm._v(" "),
                                  item.list.some(function (e) {
                                    return _vm.selectedMenu === e.link
                                  })
                                    ? _c("div", {
                                        staticClass:
                                          "border-bottom pt-2 border-success position-absolute",
                                        staticStyle: {
                                          width: "100%",
                                          left: "0",
                                          right: "0",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(item.list, function (subitem) {
                                return !_vm.isDisabledItem(subitem) &&
                                  _vm.canShowSpecific(subitem)
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        key: subitem.id,
                                        staticClass:
                                          "dropdown-item-web-header mb-1",
                                        class: {
                                          selectedMenuItemWebHeader:
                                            _vm.selectedMenu === subitem.link,
                                          subItemMenuWebHeader:
                                            subitem.id === 0,
                                          subItemTextWebHeader:
                                            subitem.id !== 0,
                                        },
                                        attrs: {
                                          disabled: !subitem.enabled,
                                          "aria-label": _vm.$t(subitem.title),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getClicked(subitem)
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "pb-1" }, [
                                          _vm._v(_vm._s(_vm.$t(subitem.title))),
                                        ]),
                                        _vm._v(" "),
                                        !subitem.link
                                          ? _c(
                                              "span",
                                              { staticClass: "disabled ml-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("common.dsbld"))
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e()
                              }),
                            ],
                            2
                          )
                        : !item.hidden &&
                          !_vm.isDisabledItem(item) &&
                          !item.list
                        ? _c(
                            "b-nav-item",
                            {
                              key: "item-" + id,
                              staticClass:
                                "text-menu subItemTextOnlyWebHeader px-1 py-0 mt-1 font-weight-bold small",
                              class: {
                                selectedMenuItemWebHeader:
                                  _vm.selectedMenu === item.link,
                              },
                              attrs: {
                                disabled: !item.enabled,
                                "link-classes": {
                                  borderSuccessMenu:
                                    _vm.selectedMenu === item.link,
                                },
                                "aria-label": _vm.$t(item.title),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getClicked(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(item.title)) +
                                  "\n          "
                              ),
                              !item.link
                                ? _c("span", { staticClass: "disabled ml-1" }, [
                                    _vm._v(_vm._s(_vm.$t("common.dsbld"))),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.link === _vm.selectedMenu
                                ? _c("div", {
                                    staticClass:
                                      "border-bottom pt-2 border-success position-absolute",
                                    staticStyle: {
                                      width: "100%",
                                      left: "0",
                                      right: "0",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }